import angular from 'angular';

import EventValueKeyFilterDirective, { selector } from './event-value-key-filter.directive';

export default angular
    .module('application.component.modals.component.event-add-modal.directive.event-value-key-filter', [])
    .directive(selector, EventValueKeyFilterDirective);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-edit-modal/directive/event-value-key-filter/index.js